import React from 'react';
import Checkbox from 'Components/Shared/Checkbox/Checkbox';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
  isChecked?: boolean;
  onChange: (isChecked: boolean) => void;
}

const FormNewsLetter: React.SFC<IProps> = ({
  isChecked,
  onChange,
}) => (
  <Checkbox style='form-newsletter' onChange={ onChange } value={ isChecked }>
    <FormattedText 
      style='sub-title medium-bold' 
      displayName='Nyhetsbrev'
      formattedName='form.emailsallowed.header'
    />
    <FormattedText 
      displayName='Jag vill få tips om aktuella föreställningar via e-post.'
      formattedName='form.emailsallowed.text'
    />
  </Checkbox>
  );

export default FormNewsLetter;


// WEBPACK FOOTER //
// ./src/components/FormNewsLetter/FormNewsLetter.tsx